import React, { useState } from 'react';
import { Box, Typography, useMediaQuery, Paper, Grow, Fade } from '@mui/material';

const items = [
  {
    id: 1,
    title: '1. Análisis y descubrimiento',
    color: '#0A6274',
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190216/ebm/iconAnalisis_u7nv3l.svg',
    description: 'Se revela el potencial y las áreas de mejora identificando el estado actual, las oportunidades, los retos y las necesidades futuras mediante un diagnóstico detallado de la empresa, la familia y el patrimonio.'
  },
  {
    id: 2,
    title: '2. Alineación y compromiso conjunto',
    color: '#35859B',
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190222/ebm/iconAlineacion_cqslzp.svg',
    description: 'Se fomenta la colaboración activa y se sincronizan objetivos, valores y esfuerzos para que todos los involucrados trabajen en una misma dirección. Esto fomenta la colaboración activa y se establece un compromiso colectivo para garantizar el éxito de las iniciativas planteadas.'
  },
  {
    id: 3,
    title: '3. Diseño y planificación de estrategias',
    color: '#84BFCB',
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190217/ebm/iconDiseno_kacolm.svg',
    description: 'Se conceptualizan y estructuran las acciones necesarias para alcanzar los objetivos. Incluye el desarrollo de un plan detallado que integra recursos, metas y cronogramas, asegurando que cada paso esté alineado con la visión general.'
  },
  {
    id: 4,
    title: '4. Implementación y ejecución',
    color: '#5D9B9B',
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190219/ebm/iconImplementacion_d2ahdg.svg',
    description: 'Se llevan a la practica las estrategias diseñadas, asegurando su correcta aplicación para garantizar resultados óptimos y sostenibles. Requiere una gestión efectiva, monitoreo constante y ajustes en tiempo real.'
  },
  {
    id: 5,
    title: '5. Fortalecimiento y capacitación',
    color: '#3B7F79',
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190218/ebm/iconFortalecimiento_cltgyo.svg',
    description: 'Se asegura su preparación para enfrentar retos futuros al consolidar conocimientos, habilidades y capacidades en los equipos o sistemas. Se enfoca en construir una base sólida para la mejora continua y el desarrollo organizacional.'
  },
  {
    id: 6,
    title: '6. Crecimiento continuo y estratégico',
    color: '#758282',
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190217/ebm/iconCrecimiento_ho1pr4.svg',
    description: 'Se avanza de manera sostenida, alineando cada logro con metas de largo plazo. Se prioriza el desarrollo equilibrado y consciente, adaptándose a las dinámicas del entorno y fortaleciendo las bases para un éxito duradero.'
  },
  {
    id: 7,
    title: '7. Evolución constructiva y sostenida',
    color: '#38383D',
    icon: 'https://res.cloudinary.com/dhoyyqszi/image/upload/v1750190217/ebm/iconCrecimiento_ho1pr4.svg',
    description: 'Proceso continuo de transformación positiva que garantiza resultados duraderos, responsables y alineados, impulsando así, el desarrollo de una organización o sistema basado en la mejora estructurada, el aprendizaje constante y la implementación de estrategias.'
  },
];

function getSectorPath(startAngle, endAngle, innerRadius, outerRadius) {
  const toRadians = angle => (Math.PI / 180) * angle;
  const x1 = outerRadius * Math.cos(toRadians(startAngle));
  const y1 = outerRadius * Math.sin(toRadians(startAngle));
  const x2 = outerRadius * Math.cos(toRadians(endAngle));
  const y2 = outerRadius * Math.sin(toRadians(endAngle));
  const x3 = innerRadius * Math.cos(toRadians(endAngle));
  const y3 = innerRadius * Math.sin(toRadians(endAngle));
  const x4 = innerRadius * Math.cos(toRadians(startAngle));
  const y4 = innerRadius * Math.sin(toRadians(startAngle));
  const largeArc = endAngle - startAngle > 180 ? 1 : 0;

  return `M${x1},${y1}
          A${outerRadius},${outerRadius} 0 ${largeArc},1 ${x2},${y2}
          L${x3},${y3}
          A${innerRadius},${innerRadius} 0 ${largeArc},0 ${x4},${y4}
          Z`;
}

export default function MetodoCircularMUI() {
  const [selected, setSelected] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);
  const isMobile = useMediaQuery('(max-width:768px)');
  const isSmallMobile = useMediaQuery('(max-width:480px)');

  // Tamaños responsivos
  const radius = isSmallMobile ? 100 : isMobile ? 140 : 220;
  const innerRadius = isSmallMobile ? 50 : isMobile ? 70 : 110;
  const rotationOffset = -120;

  const handleItemClick = (item) => {
    setSelected(item);
  };

  const handleCloseDetails = () => {
    setSelected(null);
  };

  const handleItemHover = (itemId, isHovered) => {
    setHoveredItem(isHovered ? itemId : null);
  };

  return (
    <Box sx={{ width: '100%', backgroundColor: '#FFFFF', py: 6 }}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        px: isMobile ? 1 : 2,
        py: 4,
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
      }}>
        <Box sx={{ textAlign: 'center', mb: 1, width: '100%' }}>
          <Typography sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 400,
            fontSize: isMobile ? '24px' : '32px',
            color: '#3B7F79',
            pt: isMobile ? '20px' : '1px',
            letterSpacing: '3px',
            lineHeight: 1.2
          }}>
            Nuestra <Box component="span" sx={{ fontWeight: 700 }}>metodología</Box>
          </Typography>
          <Typography sx={{
            fontFamily: 'Poppins, sans-serif',
            fontWeight: 500,
            fontSize: isMobile ? '14px' : '20px',
            letterSpacing: '3px',
            color: '#38383D',
            mt: 0.5,
            lineHeight: 1.3
          }}>
            CLAVE PARA EL ÉXITO DE NUESTROS SERVICIOS
          </Typography>
        </Box>

        <Box sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          position: 'relative'
        }}>
          <Box sx={{
            position: 'relative',
            width: radius * 2,
            height: radius * 2,
            maxWidth: '100%',
            transition: 'all 0.5s cubic-bezier(0.33, 1, 0.68, 1)',
            transform: selected ? (isMobile ? 'scale(0.8)' : 'translateX(-40px) scale(0.9)') : 'scale(1)',
            mb: isMobile ? 2 : 0,
            willChange: 'transform'
          }}>
            <svg
              width="100%"
              height="100%"
              viewBox={`-${radius} -${radius} ${radius * 2} ${radius * 2}`}
              style={{ transition: 'all 0.5s ease', opacity: selected ? 0.9 : 1 }}
              overflow={'visible'}
            >
              {items.slice(0, 6).map((item, index) => {
                const anglePerSlice = 360 / 6;
                const startAngle = anglePerSlice * index + rotationOffset;
                const endAngle = startAngle + anglePerSlice;
                const path = getSectorPath(startAngle, endAngle, innerRadius, radius);
                const midAngle = (startAngle + endAngle) / 2;
                const angleRad = (midAngle * Math.PI) / 180;
                const cx = Math.cos(angleRad) * ((innerRadius + radius) / 2);
                const cy = Math.sin(angleRad) * ((innerRadius + radius) / 2);
                const textSize = isSmallMobile ? 6 : isMobile ? 8 : 10;

                return (
                  <g 
                    key={item.id} 
                    onClick={() => handleItemClick(item)}
                    onMouseEnter={() => handleItemHover(item.id, true)}
                    onMouseLeave={() => handleItemHover(item.id, false)}
                    style={{ 
                      cursor: 'pointer',
                      transition: 'all 0.3s cubic-bezier(0.25, 1, 0.5, 1)',
                      transform: hoveredItem === item.id ? 'scale(1.05)' : 'scale(1)',
                      filter: hoveredItem === item.id ? 'drop-shadow(0px 0px 8px rgba(255,255,255,0.7))' : 'none',
                      outline: 'none'
                    }}
                  >
                    <Fade in={true} timeout={800} style={{ transitionDelay: `${index * 100}ms` }}>
                      <path 
                        d={path} 
                        fill={item.color} 
                        stroke="white" 
                        strokeWidth={hoveredItem === item.id ? '3' : '1.5'}
                        style={{ transition: 'all 0.3s ease' }}
                      />
                    </Fade>
                    
                    <foreignObject
                      x={cx - (isSmallMobile ? 24 : isMobile ? 40 : 50)}
                      y={cy - (isSmallMobile ? 30 : isMobile ? 40 : 50)}
                      width={isSmallMobile ? 48 : isMobile ? 90 : 110}
                      height={isSmallMobile ? 60 : isMobile ? 90 : 100}
                    >
                      <Box sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        overflow: 'hidden'
                      }}>
                        <Box
                          component="img"
                          src={item.icon}
                          alt={item.title}
                          sx={{
                            width: selected ? (isSmallMobile ? 30 : isMobile ? 50 : 70) : (isSmallMobile ? 20 : isMobile ? 30 : 40),
                            height: selected ? (isSmallMobile ? 30 : isMobile ? 50 : 70) : (isSmallMobile ? 20 : isMobile ? 30 : 40),
                            filter: 'brightness(0) invert(1)',
                            mb: isSmallMobile ? 0 : 0.5,
                            opacity: hoveredItem === item.id ? 1 : 0.9
                          }}
                        />
                        
                        <Fade in={true} timeout={800} style={{ transitionDelay: `${index * 100 + 300}ms` }}>
                          <Typography
                            sx={{
                              fontSize: `${textSize}px`,
                              color: '#FFFFFF',
                              fontFamily: 'Poppins, sans-serif',
                              fontWeight: 600,
                              textAlign: 'center',
                              lineHeight: 1.2,
                              px: 0.5,
                              display: selected ? 'none' : 'block',
                              transition: 'all 0.3s cubic-bezier(0.25, 1, 0.5, 1)',
                              transform: hoveredItem === item.id ? 'translateY(-3px)' : 
                                       (item.id === 3 ? 'translateX(-12px)' : 
                                       item.id === 5 ? 'translateX(12px)' : 'none'),
                              textShadow: hoveredItem === item.id ? '0 2px 10px rgba(0,0,0,0.5)' : 'none'
                            }}
                          >
                            {item.title}
                          </Typography>
                        </Fade>
                      </Box>
                    </foreignObject>
                  </g>
                );
              })}

              {/* Centro interactivo */}
              <g 
                onClick={() => handleItemClick(items[6])}
                onMouseEnter={() => handleItemHover(items[6].id, true)}
                onMouseLeave={() => handleItemHover(items[6].id, false)}
                style={{ 
                  cursor: 'pointer',
                  transition: 'all 0.3s cubic-bezier(0.25, 1, 0.5, 1)',
                  transform: hoveredItem === items[6].id ? 'scale(1.05)' : 'scale(1)',
                  filter: hoveredItem === items[6].id ? 'drop-shadow(0px 0px 12px rgba(255,255,255,0.9))' : 'none',
                  outline: 'none'
                }}
              >
                <Fade in={true} timeout={1000}>
                  <circle 
                    cx="0" 
                    cy="0" 
                    r={innerRadius - (isMobile ? 5 : 10)} 
                    fill="#2D2D2D" 
                    stroke={hoveredItem === items[6].id ? "white" : "rgba(255,255,255,0.7)"}
                    strokeWidth={hoveredItem === items[6].id ? "3" : "1.5"}
                  />
                </Fade>
                
                <foreignObject
                  x={selected ? -(isSmallMobile ? 20 : isMobile ? 30 : 40) : -(isSmallMobile ? 30 : isMobile ? 45 : 60)}
                  y={selected ? -(isSmallMobile ? 20 : isMobile ? 30 : 40) : -(isSmallMobile ? 30 : isMobile ? 45 : 60)}
                  width={selected ? (isSmallMobile ? 40 : isMobile ? 60 : 80) : isSmallMobile ? 60 : isMobile ? 90 : 120}
                  height={selected ? (isSmallMobile ? 40 : isMobile ? 60 : 80) : isSmallMobile ? 60 : isMobile ? 90 : 100}
                >
                  <Box sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}>
                    <Box
                      component="img"
                      src={items[6].icon}
                      alt={items[6].title}
                      sx={{
                        width: selected ? (isSmallMobile ? 40 : isMobile ? 60 : 80) : (isSmallMobile ? 20 : isMobile ? 30 : 40),
                        height: selected ? (isSmallMobile ? 40 : isMobile ? 60 : 80) : (isSmallMobile ? 20 : isMobile ? 30 : 40),
                        filter: 'brightness(0) invert(1)',
                        mb: isSmallMobile ? 0 : 0.5,
                        opacity: hoveredItem === items[6].id ? 1 : 0.9
                      }}
                    />
                    
                    <Fade in={true} timeout={1000} style={{ transitionDelay: '300ms' }}>
                      <Typography
                        sx={{
                          fontSize: `${isSmallMobile ? 8 : isMobile ? 10 : 13}px`,
                          color: '#FFFFFF',
                          fontFamily: 'Poppins, sans-serif',
                          fontWeight: 600,
                          textAlign: 'center',
                          lineHeight: 1.2,
                          px: 0.5,
                          display: selected ? 'none' : 'block',
                          transition: 'all 0.3s cubic-bezier(0.25, 1, 0.5, 1)',
                          transform: hoveredItem === items[6].id ? 'translateY(-3px)' : 'none',
                          textShadow: hoveredItem === items[6].id ? '0 2px 10px rgba(0,0,0,0.5)' : 'none'
                        }}
                      >
                        {items[6].title}
                      </Typography>
                    </Fade>
                  </Box>
                </foreignObject>
              </g>
            </svg>
          </Box>

          {selected && (
            <Grow 
              in={!!selected}
              timeout={500}
              style={{ transformOrigin: 'left center' }}
            >
              <Paper
                elevation={6}
                sx={{
                  width: isSmallMobile ? '90%' : isMobile ? '85%' : '480px',
                  maxHeight: '280px',
                  p: isSmallMobile ? 2 : 2.5,
                  backgroundColor: '#fff',
                  borderRadius: 3,
                  ml: isMobile ? 0 : 4,
                  mt: isMobile ? 2 : 0,
                  boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
                  position: isMobile ? 'static' : 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  transition: 'all 0.4s cubic-bezier(0.33, 1, 0.68, 1)',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0px 12px 28px rgba(0, 0, 0, 0.2)'
                  }
                }}
              >
                <Box
                  onClick={handleCloseDetails}
                  sx={{
                    display: isMobile ? 'flex' : 'none',
                    justifyContent: 'flex-end',
                    mb: 1,
                    cursor: 'pointer'
                  }}
                >
                  <Typography sx={{ color: '#0C7B83', fontWeight: 700 }}>×</Typography>
                </Box>
                <Typography variant="h6" sx={{
                  color: '#0C7B83',
                  fontWeight: 600,
                  fontSize: isSmallMobile ? '14px' : '16px',
                  fontFamily: 'Poppins, sans-serif',
                  mb: 1,
                  borderBottom: '3px solid #4B4B4B',
                  pb: 1,
                  width: 'fit-content',
                  transition: 'all 0.3s ease'
                }}>
                  {selected.title}
                </Typography>
                <Typography variant="body2" sx={{
                  color: '#4B4B4B',
                  fontSize: isSmallMobile ? '12px' : '14px',
                  fontFamily: 'Poppins, sans-serif',
                  lineHeight: 1.5,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: '-webkit-box',
                  WebkitLineClamp: 5,
                  WebkitBoxOrient: 'vertical',
                  maxHeight: '7.5em',
                  textAlign: 'justify',
                  transition: 'all 0.3s ease'
                }}>
                  {selected.description}
                </Typography>
              </Paper>
            </Grow>
          )}
        </Box>
      </Box>
    </Box>
  );
}